import React from "react";

const styles = {
  paginated: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "0px 1vw",
  },
  select: {
    margin: "0px 0.5vw",
  },
  searchGroup: {
    maxWidth: "15vw",
  },
};
const TableTitle = ({ title, endActions: EndAction, headerComponents }) => {
  return (
    title && (
      <div className="table-title d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <div className="d-flex justify-content-between align-items-center flex-grow-1">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h4 className="">{title}</h4>
            {headerComponents &&
              headerComponents?.map((Comp, index) => {
                return (
                  <div className="ml-4">
                    <Comp />
                  </div>
                );
              })}
          </div>
        </div>
        {EndAction && (
          <div className="ml-2">
            {EndAction.map((ACC, Accindex) => {
              return <ACC />;
            })}
          </div>
        )}
        {/* <button
              type="button"
              onClick={() => toggleAdd()}
              className="btn btn-gradient-dark waves-effect waves-light"
            >
              <i className="mdi mdi-plus mr-2"></i> 
            </button> */}
      </div>
    )
  );
};

export default TableTitle;
